// Function to convert GraphQL Relay ID to database ID
export function getIntegerId(globalId: string) {
    const decoded = atob(globalId);
    return Number(decoded.split(':')[1]);
}

// Function to convert database ID to GraphQL Relay ID
export function toGlobalId(type: string, id: string | number): string {
    return btoa(`${type}:${id}`);
}

export const isBase64 = (str: string) => {
    if (!str) {
        return false;
    }
    return btoa(atob(str)) === str;
};
